import React from 'react'
import { SalesPersonApi } from '../api/salespeopleApi'
import MUIDataTable from "mui-datatables";
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Notification from './Notifications'
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { validateEmail } from '../utils/misc';
import DateFnsUtils from '@date-io/date-fns';
import 'date-fns';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import VisibilityIcon from '@material-ui/icons/Visibility';
import IconButton from '@material-ui/core/IconButton';
import Warning from '@material-ui/icons/Warning';

import * as actionCreators from '../actions/user';
import PropTypes from "prop-types";


import LoadingWheel from './Loader'

function mapStateToProps(state) {
    return {
        userName: state.user.userName,
        userEmail: state.user.userEmail,
        userPhone: state.user.userPhone,
        userAddress: state.user.userAddress,
        userId: state.user.id,
        changePassword: state.user.changePassword

    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
};

const reLogin = () => {
    localStorage.clear();
    window.location = '/login';
}

import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import lightBlue from "@material-ui/core/colors/lightBlue";


@connect(mapStateToProps, mapDispatchToProps)
export class UserSettingsView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {

            showMsg: false,
            msgType: 'error', // success/error/warning
            msg: null,
            salesmanName: null,
            salesmanEmail: null,
            salesmanAddress: null,
            salesmanPhone: null,
            password: null,
            newPassword: null,
            newPasswordRep: null,
            hidden: true,
            newpassHiden: true,
            newpassRepHidden: true,
            changePassword: false
        }

    }

    componentDidMount = () => {
        this.setState({
            salesmanName: this.props.userName, salesmanEmail: this.props.userEmail,
            salesmanPhone: this.props.userPhone, salesmanAddress: this.props.userAddress,
            changePassword: this.props.changePassword
        })

    }

    updateData = () => {
        let salespersonData = {
            'username': this.state.salesmanName, 'email': this.state.salesmanEmail,
            'phone': this.state.salesmanPhone, 'address': this.state.salesmanAddress,
            'location': 'Bahia Blanca', 'id': this.props.userId
        }
        if (this.state.salesmanName == null || this.state.salesmanName == '') {
            this.setState({ msg: 'Nombre invalido', msgType: 'error', showMsg: true })
            return
        }
        if (!validateEmail(this.state.salesmanEmail)) {
            this.setState({ msg: 'Email invalido', msgType: 'error', showMsg: true })
            return
        }
        if (this.state.salesmanAddress == null || this.state.salesmanAddress == '') {
            this.setState({ msg: 'Direccion invalida', msgType: 'error', showMsg: true })
            return
        }
        if (this.state.password) {
            if (this.state.newPassword == null || this.state.newPassword != this.state.newPasswordRep) {
                this.setState({ msg: 'Las claves no coinciden', msgType: 'error', showMsg: true })
                return
            }
            salespersonData['password'] = this.state.password
            salespersonData['new_pwd'] = this.state.newPassword

        }
        SalesPersonApi.updateResource(this.props.userId, salespersonData)

            .then(response => {
                this.setState({ msg: 'Datos actualizados! Vuelva a loguearse', msgType: 'success', showMsg: true })
                // hacer un relogin
                setTimeout(reLogin, 2000)


            })
            .catch(error => {
                this.setState({ showMsg: true, msg: error.response.data.message, msgType: "error" })

            })
    }


    isDisabled = () => {
        let enabled = true;
        if (this.state.salesmanEmail == null || this.state.salesmanEmail == ''
            || this.state.salesmanEmail == this.props.userEmail) {
            enabled = false;
        }


        if (this.state.salesmanPhone == null || this.state.salesmanPhone == ''
            || this.state.salesmanPhone == this.props.userPhone) {
            enabled = false;
        }

        if (this.state.salesmanName == null || this.state.salesmanName == ''
            || this.state.salesmanName == this.props.userName) {
            enabled = false;
        }
        if (this.state.salesmanAddress == null || this.state.salesmanAddress == '') {
            enabled = false;
        }
        return !enabled;
    }

    setDate = (date) => {
        this.setState({ salesmanBirthDate: date })
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ showMsg: false });
    }

    loadCatalog = () => {
        return (<div style={{ marginTop: 150 }}>
            <Divider />
            {this.state.changePassword && <div className='col-md-12' style={{ backgroundColor: "#D4D6D8" }}>

                <Warning /> <Typography align="center" variant="h6" style={{ marginTop: -34, marginLeft: 35 }}>
                    Se requiere un cambio de clave para poder continuar
                </Typography>

            </div>}
            <Typography variant="subtitle1" gutterBottom>
                Datos Personales
                        </Typography>
            <div className='col-md-3'>
                <TextField
                    placeholder={"Nombre y apellido"}
                    value={this.state.salesmanName}
                    onInput={toInputUppercase}
                    onChange={e => {
                        let value = e.target.value;
                        value = value.replace(/[^A-Za-z\s]/gi, "");

                        this.setState({
                            salesmanName: value
                        });
                    }}
                    id="salesmanName"

                />
            </div>
            <div className='col-md-3'>
                <TextField
                    placeholder={"Direccion"}
                    onInput={toInputUppercase}
                    value={this.state.salesmanAddress}
                    onChange={e => {
                        this.setState({
                            salesmanAddress: e.target.value
                        });
                    }}
                    id="salesmanAddress"

                />
            </div>

            <div className='col-md-2'>
                <TextField
                    placeholder={"telefono"}
                    value={this.state.salesmanPhone}
                    onChange={e => {
                        let value = e.target.value;

                        value = value.replace(/[^0-9]/gi, "");

                        this.setState({
                            salesmanPhone: value
                        });
                    }}
                    id="salesmanPhone"

                />
            </div>
            <div className='col-md-2'>
                <TextField
                    placeholder={"Email"}
                    type='email'
                    value={this.state.salesmanEmail}
                    onChange={e => {
                        this.setState({
                            salesmanEmail: e.target.value
                        });
                    }}
                    id="salesmanEmail"

                />
            </div>
            <Divider />
            <div className='col-md-10' style={{ marginLeft: -10, marginTop: 20 }}>
                <Typography variant="subtitle1" gutterBottom>
                    Password
                </Typography>
                <div className='col-md-3'>
                    <div className='col-md-10'>
                        <TextField
                            placeholder={"Password Actual"}
                            type={this.state.hidden ? 'password' : 'text'}
                            value={this.state.password}
                            onChange={e => {
                                this.setState({
                                    password: e.target.value
                                });
                            }}
                            id="password"

                        />
                    </div>
                    <div className='col-md-2'>
                        <IconButton style={{ marginLeft: -40 }} onClick={(e) => this.setState({ hidden: !this.state.hidden })}><VisibilityIcon /></IconButton>
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className='col-md-10'>
                        <TextField
                            placeholder={"Nuevo Password"}
                            type={this.state.newpassHiden ? 'password' : 'text'}
                            value={this.state.newPassword}
                            onChange={e => {
                                this.setState({
                                    newPassword: e.target.value
                                });
                            }}
                            id="newPassword"

                        />


                    </div>
                    <div className='col-md-2'>
                        <IconButton style={{ marginLeft: -40 }} onClick={(e) => this.setState({ newpassHiden: !this.state.newpassHiden })}><VisibilityIcon /></IconButton>
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className='col-md-10'>
                        <TextField
                            placeholder={"Repetir nuevo password"}
                            type={this.state.newpassRepHidden ? 'password' : 'text'}
                            value={this.state.newPasswordRep}
                            onChange={e => {
                                this.setState({
                                    newPasswordRep: e.target.value
                                });
                            }}
                            id="newPasswordRep"

                        />
                    </div>
                    <div className='col-md-2'>
                        <IconButton style={{ marginLeft: -60 }} onClick={(e) => this.setState({ newpassRepHidden: !this.state.newpassRepHidden })}><VisibilityIcon /></IconButton>
                    </div>
                </div>
            </div>
            <div className="col-md-1 col-md-offset-10">
                <Button
                    onClick={this.updateData}
                    variant="contained"
                    color="primary"
                >
                    Actualizar
                    </Button>

            </div>
            <div>
                <Notification
                    open={this.state.showMsg}
                    variant={this.state.msgType}
                    message={this.state.msg}
                    onClose={this.handleClose}
                />
            </div>
        </div>
        )

    }

    render() {
        return (
            <div style={{ marginTop: 150 }}>
                {this.state.isLoading
                    ? <div className="col-md-6 col-md-offset-5">
                        <CircularProgress
                            size={80}
                            color='primary'
                            thickness={3}
                            style={{ display: 'center' }} />
                    </div>
                    : <div>{this.loadCatalog()}</div>
                }
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./src/components/UserSettings.js